import styled from '@emotion/styled';

const LeadFormContainer = styled.section`
  h1 {
    text-align: left;
    margin-bottom: 12px;
  }
  p {
    color: ${props => props.theme.primaryFontColor};
  }
`;

export default LeadFormContainer;
